export default "__VITE_ASSET__e2b89bcd__"